import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  icon: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  content: {
    width: 500,
    mt: -2,
  },
  text: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  delete: {
    ml: 2,
    mr: 1,
  },
};

export default function RemoveInspectorDialog({
  showDialog,
  closeDialog,
  onRemove,
}: any) {
  return (
    <Dialog
      open={showDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "510" }}>
        Remove Inspector From this Order?
      </DialogTitle>
      <IconButton aria-label="close" onClick={closeDialog} sx={styles.icon}>
        <CloseIcon />
      </IconButton>
      <DialogContent sx={styles.content}>
        <DialogContentText id="alert-dialog-description">
          <Typography sx={styles.text}>
            Are you sure you want to remove the inspector from this order? The
            order will be in the assign queue where another inspector will need
            to be assigned.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={closeDialog}>
          Cancel
        </Button>
        <Button sx={styles.delete} onClick={onRemove} autoFocus color="error">
          Remove Inspector
        </Button>
      </DialogActions>
    </Dialog>
  );
}
